export default __webpack_public_path__ + "static/media/pink_base.ee85c721.png";